<script>
    import {createEventDispatcher} from 'svelte/internal';

    export let value;
    export let id = '';
    export let placeholder = '';
    export let css = '';
    export let allowNewLine = false;

    let oldValue = value;

    const dispatch = createEventDispatcher();

    const onInput = event => {
        if (!allowNewLine) {
            value = value.replace(/[\r\n\t]/g, "");
        }

        // oldValue = value;
        autoSize(event.target);
    }

    const onChange = event => {
        dispatch('change', event);
    }

    const onKeyUp = event => {
        if (event.key === 'Enter' && !allowNewLine && oldValue != value) {
            onChange(event);
        }
        oldValue = value;
    }

    const onFocusIn = () => {
        dispatch('focusin');
    }

    const onFocusOut = () => {
        dispatch('focusout');
    }

    if (!id) {
        id = `ia${Math.random()}`;
    }

    const autoSize = (control = null) => {
        if (!control) {
            control = document.getElementById(id);
        }
        let input = document.getElementById(`it${id}`);
        if (input) {
            control.style.height = '';
            control.style.height = input.offsetHeight + 'px';
            // control.style.height = control.scrollHeight + 'px';
        }
    }

    // $: if (oldValue != value) {
    //     console.log("RESIZE!!!");
    //     setTimeout(() => {
    //         oldValue = value;
    //         autoSize();
    //     }, 50);
    // }

    $: {
        setTimeout(() => {
            autoSize();
        }, 50);
    }
</script>

<textarea class="auto-size {css}" {id} class:empty={ !value } bind:value="{ value }"
          on:input="{ onInput }" on:change={ onChange } on:keydown={ onKeyUp }
          on:focusin={ onFocusIn }
          on:focusout={ onFocusOut }
          {placeholder}></textarea>
<div class="input-wrapper">
    <div class="input-text {css}" id="it{id}">
        {#if !allowNewLine}
            { value }
        {:else}
            {@html value.replaceAll("\n", "<br>") }&nbsp;
        {/if}
    </div>
</div>
<style>
    .input-wrapper {
        height: 0;
        overflow: hidden;
    }

    .input-text {
        width: auto;
        height: max-content;
        background: #ccc;
        margin: 0 !important;
    }

    .auto-size {
        display: block;
        height: 1rem;
        overflow: hidden;
        resize: none;
    }

    .auto-size.empty {
        max-height: 1rem;
    }
</style>
